import { ROUTES } from '../types/global/routes.types';

export type AccountSettingsNavItem = {
    name: string;
    route: string;
    /** Sidebar / mobile label when different from sentence-cased `name`. */
    label?: string;
};

export const account_settings_data: AccountSettingsNavItem[] = [
    {
        name: 'settings',
        route: ROUTES.ACCOUNT_SETTINGS,
    },
    {
        name: 'billing',
        route: ROUTES.ACCOUNT_BILLING,
    },
    {
        name: 'notifications',
        route: ROUTES.ACCOUNT_NOTIFICATIONS,
    },
    {
        name: 'subscriptions',
        route: ROUTES.ACCOUNT_SUBSCRIPTION,
    },
    {
        name: 'communications',
        route: ROUTES.ACCOUNT_COMMUNICATIONS,
    },
    {
        name: 'preferences',
        route: ROUTES.ACCOUNT_PREFERENCES,
    },
    {
        name: 'external bank accounts',
        route: ROUTES.ACCOUNT_EXTERNAL_ACCOUNT,
        label: 'External bank accounts',
    },
];
